import * as React from 'react';
import { cn } from '@/lib/utils';

const Guide = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-guide', 'flex max-w-full flex-col gap-8', 'xl:grow xl:pt-16', className)}
    {...props}
  />
));
Guide.displayName = 'Guide';

const GuideHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-guide-header', 'xl:fixed xl:left-[108px] xl:right-[45px] xl:top-[88px]', 'xl:bg-neutral-bright xl:pb-4 xl:pt-3', 'xl:z-20 xl:flex xl:items-center xl:gap-4', className)}
    {...props}
  />
));
GuideHeader.displayName = 'GuideHeader';

const GuideTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h1
    ref={ref}
    className={cn('c-guide-title', 'mb-0 grow text-2xl font-bold text-black', className)}
    {...props}
  />
));
GuideTitle.displayName = 'GuideTitle';

const GuideActions = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-guide-actions', 'flex shrink-0 items-center gap-4', className)}
    {...props}
  />
));
GuideActions.displayName = 'GuideActions';

const GuideBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-guide-body', 'flex flex-col gap-x-[60px] gap-y-[60px]', 'xl:mr-[360px] xl:flex-row', className)}
    {...props}
  />
));
GuideBody.displayName = 'GuideBody';

const GuideContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-guide-content', 'flex flex-col items-start gap-[60px]', 'xl:grow xl:flex-row', '[&>.guide-timeline]:grow', className)}
    {...props}
  />
));
GuideContent.displayName = 'GuideContent';

const GuideSidebar = React.forwardRef(({ className, ...props }, ref) => (
  <aside
    ref={ref}
    className={cn('c-guide-sidebar', 'xl:fixed xl:right-[45px] xl:w-[280px] xl:shrink-0', className)}
    {...props}
  />
));
GuideSidebar.displayName = 'GuideSidebar';

export { Guide, GuideHeader, GuideTitle, GuideActions, GuideBody, GuideContent, GuideSidebar };
